import {$themeConfig} from '@themeConfig';

export default {
    namespaced: true,
    state: {
        layout: {
            isRTL: $themeConfig.layout.isRTL,
            // Force light mode regardless of previous localStorage value
            skin: 'light',
            routerTransition: $themeConfig.layout.routerTransition,
            type: $themeConfig.layout.type,
            contentWidth: $themeConfig.layout.contentWidth,
            menu: {
                hidden: $themeConfig.layout.menu.hidden,
            },
            navbar: {
                type: $themeConfig.layout.navbar.type,
                backgroundColor: $themeConfig.layout.navbar.backgroundColor,
            },
            footer: {
                type: $themeConfig.layout.footer.type,
            },
            lang: 'sv',
            currentUser: '',
            uuidNotification: '',
            refreshNotification: false,
            openNotifications: '',
        },
        accessDeniedOverlay: false,
        hiddenResourceId: null,
        hiddenResource: {},
        maintenanceEnabled: (() => {
            const val = String(process.env.VUE_APP_MAINTENANCE_ENABLED || '').toLowerCase();
            // Default to current behavior (enabled) if not set
            if (!val) return false;
            return val === '1' || val === 'true' || val === 'yes' || val === 'on';
        })(),
        maintenanceBannerDismissed: false,
    },
    getters: {
        currentUser: state => state.layout.currentUser,
        uuidNotification: state => state.layout.uuidNotification,
        refreshNotification: state => state.layout.refreshNotification,
        openNotifications: state => state.layout.openNotifications,
        getLocale: state => state.layout.lang,
        getAccessDeniedOverlay: state => state.accessDeniedOverlay,
        getResourceId: state => state.hiddenResourceId,
        getHiddenResource: state => state.hiddenResource,
        getMaintenanceEnabled: state => state.maintenanceEnabled,
        getMaintenanceBannerDismissed: state => state.maintenanceBannerDismissed,

    },
    mutations: {
        TOGGLE_RTL(state) {
            state.layout.isRTL = !state.layout.isRTL;
            document.documentElement.setAttribute(
                'dir',
                state.layout.isRTL ? 'rtl' : 'ltr'
            );
        },
        ADD_USER(state, payload) {
            state.layout.currentUser = payload;
        },
        UPDATE_CURRENT_ACCOUNT(state, payload) {
            state.layout.currentUser = {...state.layout.currentUser, current_account: payload}
        },
        ADD_UUID_NOTIFICATION(state, payload) {
            state.layout.uuidNotification = payload;
        },
        AddNotificationStatus(state, payload) {
            state.layout.refreshNotification = payload;
        },
        AddNotificationsValue(state, payload) {
            state.layout.openNotifications = payload;
        },
        CHANGE_LANGUAGE(state, lang) {
            state.layout.lang = lang;
            localStorage.setItem('lang', lang);
        },
        UPDATE_SKIN(state, skin) {
            // Force-disable dark skin; coerce any attempt to set 'dark' back to 'light'
            const newSkin = skin === 'dark' ? 'light' : skin;
            state.layout.skin = newSkin;

            // Update value in localStorage
            localStorage.setItem('vuexy-skin', newSkin);

            // Ensure dark-layout class is removed
            if (document.body.classList.contains('dark-layout')) {
                document.body.classList.remove('dark-layout');
            }
        },
        UPDATE_ROUTER_TRANSITION(state, val) {
            state.layout.routerTransition = val;
        },
        UPDATE_LAYOUT_TYPE(state, val) {
            state.layout.type = val;
        },
        UPDATE_CONTENT_WIDTH(state, val) {
            state.layout.contentWidth = val;
        },
        UPDATE_NAV_MENU_HIDDEN(state, val) {
            state.layout.menu.hidden = val;
        },
        UPDATE_NAVBAR_CONFIG(state, obj) {
            Object.assign(state.layout.navbar, obj);
        },
        UPDATE_FOOTER_CONFIG(state, obj) {
            Object.assign(state.layout.footer, obj);
        },
        UPDATE_ACCESS_DENIED(state, obj) {
            state.accessDeniedOverlay = obj
        },
        UPDATE_HIDDEN_RESOURCE_ID(state, obj) {
            window.localStorage.setItem('hiddenResourceId', obj.id)
            state.hiddenResourceId = obj.id

        },
        UPDATE_HIDDEN_RESOURCE(state, obj) {
            return state.hiddenResource = obj
        },
        SET_MAINTENANCE_ENABLED(state, value) {
            state.maintenanceEnabled = value;
        },
        SET_MAINTENANCE_BANNER_DISMISSED(state, value) {
            state.maintenanceBannerDismissed = value;
        },
    },
    actions: {},
};
